'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withPaddingPropTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./with-padding.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var paddingOptions = ['none', 'xx-small', 'x-small', 'small', 'medium', 'large', 'x-large', 'xx-large'];

var withPaddingPropTypes = exports.withPaddingPropTypes = {
  padding: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(paddingOptions), _propTypes2.default.arrayOf(_propTypes2.default.oneOf(paddingOptions))])
};

// TODO Add the same logic for margin.
var getPaddings = function getPaddings() {
  var padding = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var paddingToUse = typeof padding === 'string' ? [padding] : padding;

  var _paddingToUse = _slicedToArray(paddingToUse, 4),
      vertical1 = _paddingToUse[0],
      horizontal1 = _paddingToUse[1],
      vertical2 = _paddingToUse[2],
      horizontal2 = _paddingToUse[3];

  var paddings = { top: null, right: null, bottom: null, left: null };

  switch (paddingToUse.length) {
    case 0:
      return paddings;
    case 1:
      return { top: vertical1, right: vertical1, bottom: vertical1, left: vertical1 };
    case 2:
      return { top: vertical1, right: horizontal1, bottom: vertical1, left: horizontal1 };
    case 3:
      return { top: vertical1, right: horizontal1, bottom: vertical2, left: horizontal1 };
    case 4:
      return { top: vertical1, right: horizontal1, bottom: vertical2, left: horizontal2 };
    default:
      throw new Error('The array with paddings must contain max 4 settings [top, right, bottom, left]');
  }
};

function withPadding(Component) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var WithPadding = function WithPadding(_ref) {
    var className = _ref.className,
        _ref$padding = _ref.padding,
        padding = _ref$padding === undefined ? defaults.padding : _ref$padding,
        props = _objectWithoutProperties(_ref, ['className', 'padding']);

    var paddings = getPaddings(padding);

    var classes = (0, _classnames2.default)('with-padding', paddings.top && 'with-padding--padding-top-' + paddings.top, paddings.right && 'with-padding--padding-right-' + paddings.right, paddings.bottom && 'with-padding--padding-bottom-' + paddings.bottom, paddings.left && 'with-padding--padding-left-' + paddings.left, className);

    return _react2.default.createElement(Component, _extends({ className: classes }, props));
  };

  WithPadding.propTypes = _extends(Component.propTypes || {}, _extends({}, Component.propTypes, withPaddingPropTypes));

  WithPadding.defaultProps = _extends({}, Component.defaultProps);

  return WithPadding;
}

exports.default = withPadding;